export const Header_Laptop = "/assets/png/header_laptop.png";
export const Header_Phone = "/assets/png/header_phone.png";
export const ChooseInvoice = "/assets/png/chooseInvoice.png";
export const BusinessesWork = "/assets/png/businessesWork.png";
export const EmployeeWork = "/assets/png/employeesWork.png";
export const ImgFile = '/assets/svg/Invozio-chrimtmas-logo.svg';
export const DiscoverImage = '/assets/png/discover-invozio.png';
export const InvoiceMobileWatch = "/assets/png/invoicemobile.png";
export const officeImage = "/assets/png/office.png";
export const country = "/assets/png/hong-kong.png";
export const sppcolorimage = '/assets/png/spp-color-logo.png';
export const InvozioAsFreelancer = '/assets/png/invozio-help-as-a-freelancer.png';
export const FreelanceLifePageLaptop = '/assets/png/freelance-life-page-laptop.png';
export const FreelanceLifePageMan = '/assets/png/freelance-life-page-man.png';
export const newsCard1 = '/assets/png/newscard1.png';
export const newsCard2 = '/assets/png/newscard2.png';
export const newsCard3 = '/assets/png/newscard3.png';
export const newsCard4 = '/assets/png/newscard4.png';
export const newsCard5 = '/assets/png/newscard5.png';
export const newsCard6 = '/assets/png/newscard6.png';
export const newsCard7 = '/assets/png/newscard7.png';
export const newsCard8 = '/assets/png/newscard8.png';
export const newsCard9 = '/assets/png/newscard9.png';
export const Search = '/assets/svg/search.svg';
export const bookkeepingImage = '/assets/png/bookkeeping-hero-image.png';
export const StartupSectionImage = '/assets/png/startup-section-image.png';
export const FreelancerGetStarted = '/assets/png/Freelancer-get-started-hero-image.png';
export const ManageSectionImage = '/assets/png/manage-section-hero-image.png';
export const GuideIntroImage = '/assets/png/freelancing-guide-hero.png';
export const BenefitsHeroImage = '/assets/png/benefits-hero-image.png';
export const ChallengesHeroImage = '/assets/png/challenges-hero-image.png';
export const TipsHeroImage = '/assets/png/tip-hero-image.png';
export const Bullseye = '/assets/svg/bullseye.svg';
export const Chat = '/assets/svg/chat.svg';
export const Consultant = '/assets/svg/consultant.svg';
export const Development = '/assets/svg/development.svg';
export const Editing = '/assets/svg/editing.svg';
export const Marketing = '/assets/svg/marketing.svg';
export const Translation = '/assets/svg/translate.svg';
export const Writing = '/assets/svg/writing.svg';
export const Coins = '/assets/svg/coins.svg';
export const Feather = '/assets/svg/feather.svg';
export const Gift = '/assets/svg/gift.svg';
export const Like = '/assets/svg/like.svg';
export const NeutralEmoji = '/assets/svg/neutral-emoji.svg';
export const CreateAccountHeroImage = '/assets/png/create-account-hero-image.png';
export const ambasadorBrand = '/assets/png/ambassdor-brand-image.png'
export const ambasadorBrandTalk = '/assets/png/brand-ambassdor-talk-img.png'
export const LandingPopup = '/assets/png/pop-up-image.png'
export const LandingPopupMobile = '/assets/png/landing-pop-mobile.png'
export const EnglishFlag = '/assets/png/eng-flag.png'
export const SwedishFlag = '/assets/png/swedish-flag.jpg'